<template>
    <div class="modal fade" id="auto_logout" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <p style="font-weight: bold">{{$lang("Twoja sesja zaraz wygaśnie!")}}</p>
                </div>
                <div class="modal-body">
                    <p>{{$lang("Twoja sesja wygaśnie za ")}}
                        <span style="font-weight: bold">{{secondsLeft}}</span>
                        {{$lang(" sekund.")}}
                    </p>
                    <p>{{$lang("Czy chcesz przedłużyć czas sesji?")}}</p>
                </div>
                <div class="modal-footer">
                    <button @click="renewSession" type="button" class="btn btn-primary">
                        {{$lang("Tak, przedłuż sesję")}}
                    </button>
                    <a :href="logout_route">
                        <button type="button" id="logout_btn" class="btn btn-primary">{{$lang("Nie, wyloguj mnie")}}
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "end-session-alert",
        data() {
            return {
                secondsLeft: this.session_time * 60,
                warningTime: 60
            }
        },
        props: {
            session_time: {
                required: true,
                type: Number
            },
            logout_route: {
                required: true,
                type: String
            }
        },
        mounted() {
            this.countDown();
            const self = this;
            $(document).on('click keyup', function () {
                if(this.secondsLeft>this.warningTime)
                self.renewSession();
            })

        },
        methods: {
            countDown() {
                if (this.secondsLeft > 0) {
                    setTimeout(() => {
                        this.secondsLeft--;
                        this.countDown();
                    }, 1000)
                }
            },
            renewSession() {
                this.secondsLeft = this.session_time * 60;
                $("#auto_logout").modal("hide");
            }
        },
        watch: {
            secondsLeft(newVal) {
                if (newVal === this.warningTime) {
                    $("#auto_logout").modal("show");
                }
                if (newVal === 0) {
                    document.getElementById("logout_btn").click();
                }
            }
        }
    }

</script>
